<template>
  <section class="evento-wrapper" ref="sectionRef">

    <!-- FONDO -->
    <img
      :src="require('@/assets/F1.jpg')"
      alt="Fondo"
      class="fondo-textura"
    />

    <!-- RAMITA -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- TARJETA -->
    <div class="tarjeta-evento reveal">

      <!-- TITULO -->
      <p class="titulo-evento">
        Itinerario
      </p>

      <!-- TEXTO -->
      <p class="texto-romantico reveal">
        Hemos planeado un día lleno<br>
        de diversión y disfrutar todos<br>
        juntos, agradecemos tu puntualidad.
      </p>

      <!-- SEPARADOR -->
      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <!-- EVENTOS -->
      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item reveal"
        :ref="el => itemRefs[index] = el"
      >

        <img
          :src="evento.icono"
          class="poster-icon"
        />

        <div class="poster-text">

          <span class="evento-nombre">
            {{ evento.nombre }}
          </span>

          <span class="evento-hora">
            {{ evento.hora }}
          </span>

          <span
            v-if="evento.nota"
            class="evento-nota"
          >
            {{ evento.nota }}
          </span>

        </div>

      </div>

    </div>

  
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {

  name: 'ItinerarioPoster',

  setup() {

    const eventos = [

      {
        nombre: 'Banquete',
        hora: '',
        icono: require('@/assets/baqnuete.png')
      },

      {
        nombre: 'Baile',
        hora: '',
        icono: require('@/assets/baile.png')
      }

    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {

      const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry)=>{

          if(entry.isIntersecting){

            entry.target.classList.add('visible')

          }

        })

      }, { threshold: 0.15 })

      document.querySelectorAll('.reveal').forEach(el=>{
        observer.observe(el)
      })

    })

    return {
      eventos,
      itemRefs,
      sectionRef
    }

  }

}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');

/* ========= CONTENEDOR ========= */

.evento-wrapper{
  position:relative;

  width:100%;

  padding:120px 20px;

  overflow:hidden;

  display:flex;
  flex-direction:column;
  align-items:center;
}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;

  width:100%;
  height:100%;

  object-fit:cover;

  z-index:0;
}

/* ========= RAMITAS ========= */

.ramita-fondo-visual{
  position:absolute;
  top:-120px;
  left:0;

  width:100%;

  opacity:.05;

  z-index:1;

  pointer-events:none;
}

.ramita-decorativa{
  width:90px;

  margin-top:40px;

  opacity:.7;

  z-index:2;
}

/* ========= TARJETA ========= */

.tarjeta-evento{
  position:relative;
  z-index:2;

  width:100%;
  max-width:390px;

  padding:50px 28px;

  text-align:center;

  border-radius:40px;



  box-shadow:
  0 10px 40px rgba(0,0,0,.10);
}

/* ========= TITULO ========= */

.titulo-evento{
  font-family:'Playfair Display', serif;

  font-size:42px;

  line-height:1.3;

  color:#b08a5a;

  margin-bottom:18px;
}

/* ========= TEXTO ========= */

.texto-romantico{
  font-family:'Playfair Display', serif;

  font-size:21px;

  line-height:1.9;

  color:#6f6660;

  margin-bottom:12px;
}

/* ========= SEPARADOR ========= */

.separator-holder{
  display:flex;
  justify-content:center;

  margin:22px 0;
}

.separador-img{
  width:80%;
  opacity:.9;
}

/* ========= EVENTOS ========= */

.poster-item{
  margin-top:34px;

  display:flex;
  flex-direction:column;
  align-items:center;
}

/* ========= ICONOS ========= */

.poster-icon{
  width:110px;
  height:auto;

  margin-bottom:14px;

  object-fit:contain;
}

/* ========= TEXTO EVENTOS ========= */

.poster-text{
  display:flex;
  flex-direction:column;
  align-items:center;
}

.evento-nombre{
  font-family:'Playfair Display', serif;

  font-size:30px;

  color:#7a6757;

  line-height:1.5;
}

.evento-hora{
  font-family:'Poppins', sans-serif;

  font-size:18px;

  color:#a88963;

  letter-spacing:.12em;

  margin-top:6px;
}

.evento-nota{
  font-family:'Poppins', sans-serif;

  font-size:13px;

  color:#8f847c;

  margin-top:6px;
}

/* ========= ANIMACIONES ========= */

.reveal{
  opacity:0;
  transform:translateY(45px);
  transition:all 1.2s ease;
}

.reveal.visible{
  opacity:1;
  transform:translateY(0);
}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .evento-wrapper{
    padding:90px 18px;
  }

  .titulo-evento{
    font-size:36px;
  }

  .texto-romantico{
    font-size:18px;
  }

  .evento-nombre{
    font-size:25px;
  }

}

</style>